<template>
  
  <div :id="_uid" class="ui small modal">
    <div class="ui header">
      Filtrar Fechamentos de Clientes
    </div>
    <div class="content">
      <div class="ui form" :class="{ loading }">
        <div class="fields">
          <div class="eight wide field">
            <label class="form-label">Data Inicial <span class="red text">*</span></label>
            <date-picker ref="startDatePicker" :autoInit="false" @onChange="onChangeStartDate" />
          </div>         
          <div class="eight wide field">
            <label class="form-label">Data Final <span class="red text">*</span></label>
            <date-picker ref="endDatePicker" :autoInit="false" @onChange="onChangeEndDate" />
          </div>                                          
        </div>             
        <div class="fields">
          <div class="eight wide field">
            <label class="form-label">Status <span class="red text">*</span></label>
            <select-dropdown ref="statusDropdown" @onChange="onChangeStatus" />
          </div>        
          <div class="eight wide field">
            <label class="form-label">Clínica</label>
            <input v-model="filter.customerName">
          </div>
        </div>
      </div>
    </div>
    <div class="actions">
      <button class="ui cancel basic button">
        <i class="times icon"></i> Sair
      </button>      
      <button v-if="showRemoveButton" class="ui teal basic button" @click="onRemove()">
        <i class="undo icon"></i> Remover
      </button>      
      <button class="ui blue button" :class="{ disabled: !canApply }" @click="onApply()">
        <i class="checkmark icon"></i> Aplicar
      </button>
    </div>
  </div>

</template>

<script>

  import moment from "@/utils/moment"
  import CustomerInvoiceService from "@/services/customer-invoice-service"
  import modalDialog from "@/mixins/modal-dialog"
  import { DatePicker, SelectDropdown } from "@/components"

  export default {
    
    name: "CustomerInvoicesFilterModal",

    mixins: [modalDialog],

    data() {
      return {
        filter: {},
        showRemoveButton: false,
      }
    },

    components: {
      DatePicker,
      SelectDropdown,
    },

    computed: {
      canApply() {
        return (this.filter.startDate && this.filter.endDate)
      },
    },

    methods: {     
      
      onShow() {
        this.loading = true
        this.emitEvent = null
      },

      onVisible() {        
        
        this.initFilter()
        this.loadDatePickers()
        this.loadDropdowns()

        this.loading = false
      }, 

      initFilter() {

        this.$refs.startDatePicker.clearDate()
        this.$refs.endDatePicker.clearDate()
        this.$refs.statusDropdown.reset()

        if (this.$store.state.pages.filters.customerInvoices) {

          this.showRemoveButton = true
          this.filter = this.$cloneObject(this.$store.state.pages.filters.customerInvoices)

        } else {          

          this.showRemoveButton = false
          this.filter = { 
            startDate: null, 
            endDate: null, 
            status: "*", 
            customer: "",
          }
        }   
        
        this.refreshData()
      },

      loadDatePickers() {
        
        this.$refs.startDatePicker.initCalendar({ force: true })
        this.$refs.endDatePicker.initCalendar({ force: true })        
        
        if (this.filter.startDate)
          this.$refs.startDatePicker.setDate(this.filter.startDate)
        
        if (this.filter.endDate)
          this.$refs.endDatePicker.setDate(this.filter.endDate)        
      },

      loadDropdowns() {        
        this.loadStatusDropdown()
      },   
      
      loadStatusDropdown() {

        let values = [{ id: "*", value: '<i class="asterisk icon"></i> Todos' }]
        const statusList = CustomerInvoiceService.getStatusList()
        
        for (let status of statusList) {
          values.push(status)
        }

        this.$refs.statusDropdown.setValues(values, this.filter.status)
      },

      onChangeStartDate(date) {
        this.filter.startDate = date
        this.refreshData()
      },

      onChangeEndDate(date) {
        this.filter.endDate = date
        this.refreshData()          
      },

      onChangeStatus(status) {
        this.filter.status = status
        this.refreshData()
      },

      refreshData() {
        this.filter = this.$cloneObject(this.filter)
      },

      onApply() {

        this.updateStore(this.filter)

        let data = this.$cloneObject(this.filter)

        if (data.startDate)
          data.startDate = moment(data.startDate).format("YYYY-MM-DD")

        if (data.endDate)  
          data.endDate = moment(data.endDate).format("YYYY-MM-DD")
        
        this.emitEvent = { event: "onApply", data }

        this.hide()        
      },

      updateStore(filter) {

        let filters = this.$cloneObject(this.$store.state.pages.filters)

        filters.customerInvoices = filter ? this.$cloneObject(filter) : null

        this.$store.commit("pages/setFilters", filters)
      },

      onRemove() {

        this.clear()

        this.emitEvent = { event: "onRemove" }

        this.hide()      
      },

      clear() {
        this.updateStore(null)
      },
    },
  }

</script>